var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShares(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 18.073V14.24C8.796 14.24 5.502 15.727 3 19c1.008-4.672 3.798-9.328 10.8-10.273V5l7.2 6.527-7.2 6.546z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjggMTguMDcyNVYxNC4yNEM4Ljc5NiAxNC4yNCA1LjUwMiAxNS43Mjc1IDMgMTlDNC4wMDggMTQuMzI3NSA2Ljc5OCA5LjY3MjUgMTMuOCA4LjcyNzVWNUwyMSAxMS41Mjc1TDEzLjggMTguMDcyNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgShares as ReactComponent };